import { FormItemTypes } from '@bimser/core';
import PanelBase from '../../base/PanelBase';
import { IPanelProperties } from './entities/IPanelProperties';
import { JSX } from 'react';
import { ICSSProperties } from '../../../../entities/common';

export default class Panel extends PanelBase {
	constructor() {
		super();

		this.controlType = FormItemTypes.EControlTypes.Panel;

		this.caption.visible = false;
	}

	initialize() {
		super.initialize();
		this.title.setData({ [this.__form.currentLanguage.culture]: this.name });
	}

	__getPanelContainerStyles(): ICSSProperties {
		return {
			...this.style,
			minHeight: '150px',
			backgroundColor: 'inherit'
		};
	}

	__loadProperties(data: IPanelProperties) {
		super.__loadProperties(data);
	}

	__render(children?: JSX.Element) {
		return super.__render();
	}
}
